// Module
var code = "<div class=\"url-with-name\"> <a ng-if=\"vm.url\" ng-href=\"{{vm.url}}\" ng-click=\"vm.navigate()\">{{vm.name}}</a> <span ng-if=\"!vm.url\">{{vm.name}}</span> </div> ";
// Exports
module.exports = code;